import { Component, EventEmitter, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';

import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { FilesActions } from 'src/app/common/store/actions/files.actions';
import { NumberDialogComponent } from 'src/app/public/common/components/number-dialog/number-dialog.component';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { FileData } from 'src/app/public/common/models/file-data.model';
import { Booking } from 'src/app/public/rent/models/booking.model';
import { CarBusinessLine } from '../../constants/car-basic-data';
import { Car } from '../../models/car.model';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';

import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@Component({
    selector: 'app-car-card-account',
    templateUrl: './car-card-account.component.html',
    styleUrls: ['./car-card-account.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatCardModule, MatProgressSpinnerModule, MatIconModule, MatDatepickerModule, CdkOverlayOrigin]
})
export class CarCardAccountComponent implements OnInit {

  @Input() businessLine?: CarBusinessLine;
  
  @Input() car: Car = new Car();
  @Input() isFavorite: boolean = false;;
  @Input() isSeller: boolean = false;
  @Input() carImagesFolder: FileData[] = [];

  currentImageIndex: number = 0;

  currentImageIndexSubject:BehaviorSubject<number>;

  currentImage: any;
  
  fetchingImage: boolean = true;

  showBookingCalendar: boolean = false;

  constructor(
    private router: Router,
    private store: Store, 
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog) {

      this.currentImageIndexSubject = new BehaviorSubject<number>(0);
    }

  ngOnInit(): void {

    this.currentImageIndexSubject.subscribe(
      (i: number) =>  {
        this.currentImage = this.getCarImage(i);
      }
    );
    
    this.currentImage = this.getCarImage(0);
  }

  ngOnChanges(changes: SimpleChanges): void {
    
    const latestImagesFolder = changes['carImagesFolder'];
    if (latestImagesFolder != undefined) {
      if ((latestImagesFolder.currentValue?.length as number) === 1) {
        
        this.currentImageIndexSubject.next(0);
      }
    }
  }

  moneyFormat(s: string): string{
    return AppFunctions.numberWithSpaces(s);
  }

  dateFormat(dt: string): string{

    return AppFunctions.stringToDate(dt);
  }

  createImageFromBlob(imageData: Blob): any {
    let objectUrl = URL.createObjectURL(imageData);     
    return this.sanitizer.bypassSecurityTrustUrl(objectUrl);    
  }

  getCarImage(i: number): any{

    if(this.carImagesFolder != undefined && this.carImagesFolder.length > 0 ){
      let objectUrl = URL.createObjectURL(this.carImagesFolder[i].blob);     
      return this.sanitizer.bypassSecurityTrustUrl(objectUrl); 
    }
  }

  openOfferDialog(carId: string): void {
    let amount = 0;
    
    const dialogRef = this.dialog.open(NumberDialogComponent, {
      data: {amount: amount, label: "Offer"}
    });

    dialogRef.afterClosed().subscribe((result: number) => {
      console.log('New offer = '+result+ " car Id = "+carId);

      if(result > 0 )
        this.store.dispatch(DealerActions.createNewCarOfferSubmit( {carId: carId, amount: result }));
    });
  }

  goToCarDetailsPage(carId: string): any{

    switch(this.businessLine!.toString()){

      case CarBusinessLine.BUY.toString(): {
        this.router.navigate(
          ['/buy/details'],
          { queryParams: { id: carId} }
        );
        break;
      }

      case CarBusinessLine.RENT.toString(): {
        this.router.navigate(
          ['/rent/booking'],
          { queryParams: { id: carId} }
        );
        break;
      }
    } 
  }

  goToSellerPage(sellerId: string): any{

    console.log("seller id = "+sellerId)

    this.router.navigate(
      ['/account/seller-public'],
      { queryParams: { id: sellerId } }
    );
  }

  nextImage(): void{
    console.log("current = "+this.currentImageIndex);

    if(this.currentImageIndex === this.carImagesFolder.length-1)
      this.currentImageIndex = 0;
    else 
      this.currentImageIndex++;
    console.log("next = "+this.currentImageIndex);
    this.currentImageIndexSubject.next(this.currentImageIndex);
  }

  prevImage(): void{
    console.log("current ="+this.currentImageIndex);
    if(this.currentImageIndex === 0 )
      this.currentImageIndex = this.carImagesFolder.length-1;
    else 
      this.currentImageIndex--;
    
    console.log("prev ="+this.currentImageIndex);
    this.currentImageIndexSubject.next(this.currentImageIndex);
  }

  uploadImage(carId: string, event: any, ): void {

    let files: File[] = event.target.files;
    console.log('file name = '+files[0].name);

    if(files != undefined && files.length > 0){
      this.store.dispatch(FilesActions.uploadCarImageSubmit({ carId: carId, file: files[0] }));
    }
  }

  filterBookedDates = (date: Date): boolean => {

    let available: boolean = true;

    this.car.allBookings.forEach(
      (booking: Booking) => {
        if (booking.endDate >= ""+date.valueOf() && ""+date.valueOf()  >= booking.startDate) {
          available = false;
          return;
        }
      }
    );
    return available;
  }
}
